import { css } from "@obby/components";

export const styles = {
  inPersonClassPage: css({
    backgroundColor: "$pampas"
  }),

  header: css({
    padding: "73px 0 32px",
    backgroundColor: "white",
    "@md": {
      paddingTop: "118px"
    },
    "@lg": {
      paddingTop: "135px"
    }
  }),

  topBar: css({
    top: "0",
    width: "100%",
    position: "fixed",
    zIndex: "$sticky",
    backgroundColor: "white",

    "@sm": {
      borderTop: "1px solid $athensGray",
      position: "sticky",
      top: "$mdTop"
    },
    "@md": {
      position: "sticky"
    },
    "@lg": {
      top: "$lgTop"
    },

    variants: {
      isOnSale: {
        true: {
          "@sm": {
            top: "$mdTop"
          },
          "@lg": {
            top: "$lgTop"
          }
        }
      }
    }
  }),

  footerBar: css({
    bottom: "0",
    width: "100%",
    position: "fixed",
    zIndex: "$sticky",
    borderTop: "1px solid $athensGray",

    "@md": {
      display: "none"
    }
  }),

  section: css({
    width: "100%",
    marginBottom: "$32",

    "@sm": {
      marginBottom: "76px"
    },
    "@md": {
      marginBottom: "110px"
    },
    "@lg": {
      marginBottom: "124px"
    },

    ".responsive-class-section__header": {
      "@md": {
        position: "sticky",
        top: "204px"
      },
      "@lg": {
        top: "221px"
      }
    },
    ".beacon": {
      top: "calc(-128px + 20px)",
      "@sm": {
        top: "calc(-111px - 54px)"
      },
      "@md": {
        top: "calc(-111px - 93px)"
      },
      "@lg": {
        top: "calc(-128px - 93px)"
      }
    },

    variants: {
      variant: {
        faq: {
          ".responsive-class-section__title": {
            textTransform: "none"
          }
        }
      },
      isOnSale: {
        true: {
          ".responsive-class-section__header": {
            "@md": {
              position: "sticky",
              top: "calc(166px + 38px)"
            },
            "@lg": {
              top: "calc(183px + 38px)"
            }
          },
          ".beacon": {
            "@sm": {
              top: "calc(-111px - 54px - 38px)"
            },
            "@md": {
              top: "calc(-166px - 38px)"
            },
            "@lg": {
              top: "calc(-183px - 38px)"
            }
          }
        }
      }
    }
  }),
  tagListWrapper: css({
    display: "flex",
    flexWrap: "wrap",
    lineHeight: "2",
    margin: "0 -7px",
    "@md": {
      display: "block"
    }
  }),

  tagListItem: css({
    whiteSpace: "nowrap",
    display: "inline-block",
    textTransform: "capitalize",
    fontSize: "$16",
    fontWeight: "600",
    outline: "none !important",
    "-webkit-font-smoothing": "antialiased",
    color: "$camelot",

    "@md": {
      whiteSpace: "normal"
    },
    "&:after": {
      content: ","
    },
    "&:last-child:after": {
      content: ""
    },
    "&:visited": {
      color: "$camelot"
    },
    "&:hover": {
      color: "$ebonyClay",
      textDecoration: "underline"
    }
  }),

  archiveNote: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$18"
  }),

  link: css({
    color: "$emeraldish"
  })
};
